<template>
  <div class="results">
    <header class="b-header">
      <h2 style="margin-bottom:0">{{ $t('results') }}</h2>
    </header>
    <main id="capture" class="b-main">
      <p v-if="!isPhonemes">
        {{ $t('description') }}
      </p>
      <p v-if="isPhonemes">
        Στον τομέα άρθρωση-φωνολογία κατ΄εξαίρεση ο Mr.Blue γίνεται όλος γκρί όταν το παιδί δεν εκφέρει κάποιο φώνημα
        που θα έπρεπε να παράγει με βάση την ηλικία του. Στόχος του τομέα αυτού είναι να έχετε στην διαθεσή σας τις
        ηλικίες κατάκτησης των φωνημάτων και να εντοπίζετε τυχόν αποκλίσεις.
      </p>
      <Mparbas />
      <br />
      <br />
      <a href="#" id="blank"></a>
      <a href="#" class="btn btn-primary btn-lg btn-block" v-on:click="takeCapture()"
        >{{ $t('save') }}</a
      >
    </main>
  </div>
</template>

<i18n>
  {
  "el": {
  "results": "Αποτελέσματα",
  "description": "Με βάση τις απαντήσεις σας στον Mr.blue διακρίνονται γκρί και μπλέ σημεία. Τα γκρί μας δείχνουν τυχόν αποκλίσεις είναι καλό να διερευνήσετε τις δεξιότητες του παιδιού. Αποθηκεύστε ή εκτυπώστε το αποτέλεσμα του Mr.Blue έτσι θα μπορείτε να τον χρησιμοποιήσετε ξανά για να παρατηρήσετε την βελτίωση του παιδιού σας.",
  "save": "Αποθήκευση ή αποστολή αποτελέσματος"
  },
  "en": {
  "results": "Results",
  "description": "Based on your answers, grey and blue parts are formed on Mr. Blue. The grey zones show any deviations from the norm for the particular age. If any deviations are shown, it is advisable to further assess your child's skills. Save or print Mr. Blue results so that you can reuse them in order to monitor your child's progress.",
  "save": "Save or share Result"
  }
  }
</i18n>

<script>
import JsPDF from 'jspdf'
import html2canvas from 'html2canvas'

import Mparbas from '@/components/Mparbas.vue'
import i18n from '../i18n'

export default {
  name: 'Results',
  title: i18n.locale === 'en' ? 'Results' : 'Αποτελέσματα',
  data() {
    return {}
  },
  components: {
    Mparbas
  },
  props: ['questResults', 'isPhonemes'],
  methods: {
    getMyResult: function() {
      /**
       * TODO: DOCUMENT THIS
       * !SHOULD IMPROVE?
       */
      const _this = this
      const $questResults = _this.questResults

      // LOAD BLACK ASSETS
      const manageImg = document.querySelectorAll('.manageimage')
      for (let i = 0; i < manageImg.length; ++i) {
        const imgSrc = manageImg[i].dataset.src
        manageImg[i].src = require('@/assets/imgs/black/' + imgSrc)
      }

      $questResults.forEach((item, index) => {
        let changeColor = false
        let list

        if (item.value === 'yes') changeColor = true
        if (item.isInverted) changeColor = !changeColor

        if (changeColor) {
          list = document.querySelectorAll('img[data-prt="' + index + '"]')
          for (let i = 0; i < list.length; ++i) {
            const changeImgSrc = list[i].dataset.src
            list[i].src = require('@/assets/imgs/blue/' + changeImgSrc)
          }
        }
      })
    },
    getMyPhonemesResult: function() {
      /**
       * TODO: DOCUMENT THIS
       * !SHOULD IMPROVE?
       */
      const manageImg = document.querySelectorAll('.manageimage')
      let assetDir = 'blue/'

      if (this.questResults.length) {
        assetDir = 'black/'
      }

      for (let i = 0; i < manageImg.length; ++i) {
        const imgSrc = manageImg[i].dataset.src
        manageImg[i].src = require('@/assets/imgs/' + assetDir + imgSrc)
      }
    },
    takeCapture: function() {
      /**
       * TODO: DOCUMENT THIS
       * !SHOULD IMPROVE?
       */
      document.querySelector('#capture').classList.add('taking-capture')

      html2canvas(document.querySelector('#capture'), {
        allowTaint: false,

        useCORS: true,
        removeContainer: true,
        scrollX: 0,
        scrollY: 0,
        width: 800,
        height: 1024,
        x: 0,
        y: 0,
        scale: window.devicePixelRatio
      }).then((canvas) => {
        const contentDataURL = canvas.toDataURL('image/png')
        const imgWidth = 210
        const pageHeight = 295
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        let heightLeft = imgHeight
        const pdf = new JsPDF('p', 'mm', 'a4') // A4 size page of PDF
        let position = 5

        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
        heightLeft -= pageHeight

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight
          pdf.addPage()
          pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
          heightLeft -= pageHeight
        }
        pdf.save('MYPdf.pdf') // Generated PDF
        document.querySelector('#capture').classList.remove('taking-capture')
      })
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.isPhonemes) {
        this.getMyPhonemesResult()
      } else {
        this.getMyResult()
      }
    })
  }
}
</script>
